import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import LoginForm from '../../LoginForm';
import SignupForm from '../../SignupForm';
import ForgotPasswordForm from '../../ForgotPasswordForm';
import ForgotSuccess from '../../ForgotSuccess';
import { getUserContext } from '../../../actions/UserActions';

const AuthStateComponent = {
  signup: SignupForm,
  forgot: ForgotPasswordForm,
  forgotSuccess: ForgotSuccess,
  login: LoginForm,
};

class AuthModal extends Component {
  constructor(props) {
    super(props);

    this.onFacebookSuccess = this.onFacebookSuccess.bind(this);
    this.onLoginSuccess = this.onLoginSuccess.bind(this);
    this.onSignupSuccess = this.onSignupSuccess.bind(this);
    this.setAuthState = this.setAuthState.bind(this);

    this.state = {
      authState: this.props.authState,
    };
  }

  onFacebookSuccess(response) {
    this.onLoginSuccess(response);
  }

  onLoginSuccess(response) {
    const { hideModalFn, onUpdateUserContext, referralPage } = this.props;

    onUpdateUserContext().then(() => {
      if (response.has_wedding_account) {
        if (referralPage) {
          window.location = referralPage;
        } else {
          browserHistory.push('/wedding/manage');
        }
        hideModalFn();
      } else if (response.has_registry) {
        browserHistory.push('/wedding/from-registry');
        hideModalFn();
      } else {
        browserHistory.push('/wedding/onboard?product=WEDDING_WEBSITE');
        hideModalFn();
      }
    });
  }

  onSignupSuccess() {
    const { selectedThemeId, onUpdateUserContext, hideModalFn } = this.props;

    const next = selectedThemeId
      ? `/wedding/onboard/${selectedThemeId}`
      : '/wedding/onboard?product=WEDDING_WEBSITE';

    onUpdateUserContext().then(() => {
      browserHistory.push(next);
      hideModalFn();
    });
  }

  setAuthState(authState) {
    const { hideModalFn } = this.props;
    if (authState === 'signup') {
      window.location.href = '/onboard/select-product';
      hideModalFn();
    } else {
      this.setState({ authState });
    }
  }

  render() {
    const { hideModalFn } = this.props;
    const { authState } = this.state;
    const AuthComponent = AuthStateComponent[authState];
    if (!AuthComponent) hideModalFn();

    return (
      <AuthComponent
        onFacebookSuccess={this.onFacebookSuccess}
        onLoginSuccess={this.onLoginSuccess}
        onSignupSuccess={this.onSignupSuccess}
        hideModalFn={hideModalFn}
        setAuthState={this.setAuthState}
        selectedThemeId={this.selectedThemeId}
      />
    );
  }
}

AuthModal.propTypes = {
  authState: PropTypes.oneOf(['login', 'signup', 'forgot']),
  hideModalFn: PropTypes.func.isRequired,
  onUpdateUserContext: PropTypes.func.isRequired,
  selectedThemeId: PropTypes.number,
  productOptions: PropTypes.shape({}),
  referralPage: PropTypes.string,
};

AuthModal.defaultProps = {
  authState: 'login',
  // eslint-disable-next-line react/default-props-match-prop-types
  hideModalFn: () => {},
};

const mapDispatchToProps = dispatch => ({
  onUpdateUserContext: () => dispatch(getUserContext()),
});

export default connect(null, mapDispatchToProps)(AuthModal);



// WEBPACK FOOTER //
// ./src/components/common/auth/AuthModal.jsx